import { MaterialUICore, DrawerHeader } from '@iclinic/design-system';

const { styled } = MaterialUICore;

export const CalculatorDrawerHeader = styled(DrawerHeader)({
  marginTop: '50px',
});
